import Consent, { consentSchema } from './Consent';
import { useCustomForm } from './useCustomForm';

export { default as FormCheckbox } from './FormCheckbox';
export { default as FormDate } from './FormDate';
export { default as FormDateRange } from './FormDateRange';
export { createFormFieldStack } from './FormFieldsContainerSupportDisplayVariant';
export { default as FormFileInput } from './FormFileInput';
export { default as FormSelect } from './FormSelect';
export { default as FormSwitch } from './FormSwitch';
export { default as FormTextEditor } from './FormTextEditor';
export { default as FormTextInput } from './FormTextInput';
export { default as MaskedDateInput } from './MaskedDateInput';
/**
 * TODO:
 *  1. delete existing GenerateFormFields
 *  2. rename the new one to GenerateFormFields
 */
export { default as Address, type TAddressProps, type TSameAsAddress } from './Address';
export {
  default as AddressWithCountrySelect,
  type TAddressWithCountrySelectProps,
} from './AddressWithCountrySelect';
export { default as CircularProgressButton } from './CircularProgressButton';
export { default as DisplayAlertErrors } from './DisplayAlertErrors';
export { default as DisplayErrors } from './DisplayErrors';

export * from './FormGenerator';

export * from './FormDateRange';

export { Consent, consentSchema, useCustomForm };
